/**
 * Generic asset upload capacity is a Runtime product policy, not scene content.
 * Older scenes may still contain this field in their serialized runtime settings.
 */
export function withoutSceneAssetUploadCapacity(runtimeSettings = {}) {
  const settings = { ...runtimeSettings };
  delete settings.assetUploadCapacity;
  return settings;
}
